import { render, staticRenderFns } from "./updateImg.vue?vue&type=template&id=63395c4c"
import script from "./updateImg.vue?vue&type=script&lang=js"
export * from "./updateImg.vue?vue&type=script&lang=js"
import style0 from "./updateImg.vue?vue&type=style&index=0&id=63395c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports